import yup from 'utils/yup';

export const initialAccountCancellationData = {
  feedback: null as any,
  reason: '',
};

export const accountCancellationValidationSchema = yup.object().shape({
  feedback: yup.mixed().required(),
  reason: yup.mixed().when('feedback', {
    is: (feedback: any) => (feedback?.reasonLabel ? true : false),
    then: yup.string().min(20).required(),
    otherwise: yup.string().notRequired(),
  }),
});
